// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.filter-btn[data-v-26feddd9] {\n  font-size: var(--fs-input);\n  margin-top: 0.1rem;\n  margin-bottom: 0.1rem;\n  min-height: 40px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
